export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";